import React from 'react';
import './style.css';

const VRPage = () => {
    return (
        <div className="vr-page-container">
            <iframe
                src="/vr/index.html"
                title="Caobangceritage VR"
                className="vr-iframe"
                allowFullScreen
            />
        </div>
    );
};

export default VRPage; 